module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/anli_Star_gray.0874b.png";